<template>
  <v-container class="margen_paginas pt-7" fluid>

    <v-card
      class="mt-1"
      style="background: #E8EAF6"
    >
      <v-card-title class="pa-2 pl-4" style="background: #b0b0c0">
        <v-icon class="mr-3">mdi-face-agent</v-icon>
        <span style="font-size: 20px; font-weight: 400">
        {{ $t ('Asistencia remota') }}
        </span>
      </v-card-title>

      <v-container fluid style="background: #dcdcd0; border-bottom: 1px solid #BBBBBB">
        <v-row class="mt-0">
          <!-- aparcamiento -->
          <v-col cols="12" lg="4">
            <v-select
              :items="instalaciones"
              item-value="id_ins"
              item-text="nom"
              v-model="instalacionSeleccionada"
              return-object
              background-color="#dcdcd0"
              prepend-icon="mdi-file-powerpoint-box"
              dense
              hide-details
              :label="$t ('Aparcamiento')"
              :menu-props="{ maxHeight: '80vh' }"
              @change="seleccionInstalacion"
            >
              <template slot="append-outer">
                 <v-chip class="py-3" small outlined @click="abrirSinopticoAparcamiento">
                  <v-icon small left>
                    mdi-monitor
                  </v-icon>
                  {{ $t ('Sinóptico') }}
                </v-chip>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <!-- dispositivo de interfonia -->
          <v-col cols="12" md="4">
            <v-select
              :items="dispositivos_interfonia_IS"
              item-value="id_disint"
              item-text="des"
              v-model="interfoniaSeleccionada"
              return-object
              background-color="#dcdcd0"
              prepend-icon="mdi-phone-in-talk"
              dense
              hide-details
              :label="$t ('Dispositivo de interfonía')"
              :menu-props="{ maxHeight: '80vh' }"
              @change="seleccionDispositivoInterfonia"
            ></v-select>
          </v-col>

          <!-- aparato -->
          <v-col cols="12" md="4">
            <v-select
              :items="aparatos_IS"
              item-value="id_apa"
              item-text="des"
              v-model="aparatoSeleccionado"
              return-object
              background-color="#dcdcd0"
              prepend-icon="mdi-boom-gate"
              dense
              hide-details
              :label="$t ('Aparato')"
              :menu-props="{ maxHeight: '80vh' }"
              @change="seleccionAparato"
            ></v-select>
          </v-col>

          <!-- cámara -->
          <v-col cols="12" md="4">
            <v-select
              :items="camaras_IS"
              item-value="id_cam"
              item-text="des"
              v-model="camaraSeleccionada"
              return-object
              background-color="#dcdcd0"
              prepend-icon="mdi-video-outline"
              dense
              hide-details
              :label="$t ('Cámara')"
              :menu-props="{ maxHeight: '80vh' }"
              @change="seleccionCamara"
            ></v-select>
          </v-col>
        </v-row>
        <div v-if="!aparatoSeleccionado" style="height: 12px"></div>
      </v-container>

      <v-container v-if="aparatoSeleccionado" fluid>
        <v-row>
          <!-- <v-col cols="12" md="6" class="d-flex justify-center align-start"> -->
          <v-col cols="12" md="6" class="d-flex justify-center justify-md-end align-center">
            <v-card v-if="camaraSeleccionada" class="d-inline-block mr-3" width="100%" max-width="560">
              <v-card-text class="pa-3">
                <h3 v-if="camaraAMostrar.url" class="mb-1">{{camaraAMostrar.des}}</h3>
                <VisorCamaraHLS :url="camaraAMostrar.url" :key="camaraAMostrar.url" />
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-center justify-md-start align-center">
          <!-- <v-col cols="12" md="6" class="d-flex justify-center align-center"> -->
            <div v-if="aparatoSeleccionado" style="width: 400px">
              <ControlRemotoAparato
                :objeto-aparato="aparatoSeleccionado"
                :objeto-estados="$global.estadoAparatos"
                :sagabroker="$sagabroker"
                :ventana-gestion-poste="$refs['vgp']"
                :ventana-gestion-cajero="$refs['vgca']"
                :ventana-seleccion-cobro-para-imprimir="$refs['vscpi']"
                :ventana-gestion-ticket-perdido="$refs['vgtp']"
              />
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <VisorEventosSAGA
              :key="aparatoSeleccionado.id_apa"
              :id-instalacion="instalacionSeleccionada.id_ins"
              :id-aparato="aparatoSeleccionado.id_apa"
              :titulo="$t ('Eventos')"
              busqueda-rapida
              dense
            />
          </v-col>
        </v-row>
      </v-container>

      <MonitorizacionAparcamiento :id-instalacion="instalacionSeleccionada ? instalacionSeleccionada.id_ins : 0" />
      <VentanaGestionPoste ref="vgp" />
      <VentanaGestionCajero ref="vgca" />
      <VentanaSeleccionCobroParaImprimir ref="vscpi" />
      <VentanaGestionTicketPerdido ref="vgtp" />
    </v-card>
  </v-container>
</template>

<script>
import api from "@/api";
import VisorCamaraHLS from "@/components/VisorCamaraHLS.vue";
import ControlRemotoAparato from "@/components/ControlRemotoAparato.vue";
import VentanaGestionPoste from "@/components/VentanaGestionPoste.vue";
import VentanaGestionCajero from "@/components/VentanaGestionCajero.vue";
import VentanaSeleccionCobroParaImprimir from "@/components/VentanaSeleccionCobroParaImprimir.vue";
import VentanaGestionTicketPerdido from "@/components/VentanaGestionTicketPerdido.vue";
import MonitorizacionAparcamiento from '@/components/MonitorizacionAparcamiento.vue';
import VisorEventosSAGA from "@/components/VisorEventosSAGA.vue";

export default {
  components: {
    VisorCamaraHLS,
    ControlRemotoAparato,
    VentanaGestionPoste,
    VentanaGestionCajero,
    VentanaSeleccionCobroParaImprimir,
    VentanaGestionTicketPerdido,
    MonitorizacionAparcamiento,
    VisorEventosSAGA
  },
  data: () => ({
    instalaciones: [],
    aparatos: [],
    dispositivos_interfonia: [],
    camaras: [],

    instalacionSeleccionada: null,
    interfoniaSeleccionada: null,
    aparatoSeleccionado: null,
    camaraSeleccionada: null,
  }),
  computed: {
    identificadorInterfoniaAGestionar () {
      return this.$global.identificadorInterfoniaAGestionar;
    },
    dispositivos_interfonia_IS () {
      if (!this.instalacionSeleccionada) return [];
      return this.dispositivos_interfonia.filter (dispositivo_interfonia => (dispositivo_interfonia.id_ins == this.instalacionSeleccionada.id_ins));
    },
    aparatos_IS () {
      if (!this.instalacionSeleccionada) return [];
      return this.aparatos.filter (aparato => (aparato.id_ins == this.instalacionSeleccionada.id_ins));
    },
    camaras_IS () {
      if (!this.instalacionSeleccionada) return [];
      return this.camaras.filter (camara => (camara.id_ins == this.instalacionSeleccionada.id_ins));
    },
    camaraAMostrar () {
      return this.camaraSeleccionada ? this.camaraSeleccionada : {};
    },
    codigoAparatoSeleccionado () {
      if (!this.aparatoSeleccionado) return null;
      return this.aparatoSeleccionado.cod;
    }
  },
  methods: {
    seleccionarInterfoniaAGestionar() {
      if (this.identificadorInterfoniaAGestionar) {
        let dispositivo_interfonia = this.dispositivos_interfonia.find (elemento => elemento.id_disint == this.identificadorInterfoniaAGestionar);
        this.instalacionSeleccionada = this.instalaciones.find (elemento => elemento.id_ins == dispositivo_interfonia.id_ins);

        this.interfoniaSeleccionada = dispositivo_interfonia;
        this.seleccionDispositivoInterfonia (dispositivo_interfonia);
        //this.$global.identificadorInterfoniaAGestionar = undefined;
      }
    },
    seleccionInstalacion (instalacion) {
      this.aparatoSeleccionado = null;
      this.camaraSeleccionada = null;
      let id_disint_guardado = this.$store.leer_preferencia ('id_disint', null, 'dispositivoInterfonia', instalacion.id_ins);
      this.interfoniaSeleccionada = this.dispositivos_interfonia.find (elemento => elemento.id_disint == id_disint_guardado);
      if (this.interfoniaSeleccionada)
        this.seleccionDispositivoInterfonia (this.interfoniaSeleccionada);
    },
    seleccionDispositivoInterfonia (dispositivoInterfonia) {
      this.aparatoSeleccionado = this.aparatos.find (elemento => elemento.id_apa == dispositivoInterfonia.id_apa);
      this.camaraSeleccionada = this.camaras.find (elemento => elemento.id_cam == dispositivoInterfonia.id_cam1);
      this.$store.guardar_preferencia ('id_disint', dispositivoInterfonia.id_disint, null, 'dispositivoInterfonia', this.instalacionSeleccionada.id_ins);
    },
    seleccionAparato () {
      this.interfoniaSeleccionada = null;
      let dispositivo_interfonia = this.dispositivos_interfonia.find (elemento => elemento.id_apa == this.aparatoSeleccionado.id_apa);
      if (dispositivo_interfonia)
        this.camaraSeleccionada = this.camaras.find (elemento => elemento.id_cam == dispositivo_interfonia.id_cam1);
      else
        this.camaraSeleccionada = null;
    },
    seleccionCamara () {
      this.interfoniaSeleccionada = null;
    },
    abrirSinopticoAparcamiento () {
      this.$router.push ({path: "/panel/sinopticoAparcamiento"});
    }
  },
  watch: {
    instalacionSeleccionada () {
      if (this.instalacionSeleccionada)
        this.$store.guardar_preferencia ('id_instalacion_seleccionada', this.instalacionSeleccionada.id_ins, null, 'controlRemoto');
    },
    identificadorInterfoniaAGestionar() {
      if (this.identificadorInterfoniaAGestionar)
        this.seleccionarInterfoniaAGestionar();
    }
  },
  created() {
    api.obtenerInstalacionesAparatosInterfoniasCamaras ({omitirFiltroInstalaciones: 1})
      .then ((respuesta) => {
        this.instalaciones = respuesta.data.instalaciones;
        this.dispositivos_interfonia = respuesta.data.dispositivos_interfonia;
        this.aparatos = respuesta.data.aparatos;
        this.camaras = respuesta.data.camaras;

        // al cargar la pagina, aplicamos la seleccion manualmente:
        this.seleccionarInterfoniaAGestionar();
      });
  }
};
</script>

<style>
</style>